export const treemapPadding = 20
export const bubblePadding = 10
export const textSpacingFromCircle = 0
export const searchMatchColor = "red"
export const estimatedLetterWidth = 7
